/* eslint-disable max-len */
import VOLTQuestion from 'images/coin-pages/questions/volt.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const voltPage: ICoinPageData = {
  title: 'coin_1090',
  description: 'coin_1091',
  // description:
  //   'Get a Volt Inu loan. Receive up to 90% of your VOLT loan collateral in cash or crypto and continue holding. Borrow Volt Inu instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, locale, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Volt Inu' }) }}
    />
  ),
  questionsBlock: {
    image: VOLTQuestion,
    questions: [
      {
        title: 'coin_1092',
        answer: 'coin_1093',
      },
      {
        title: 'coin_1094',
        answer: 'coin_1095',
      },
      {
        title: 'coin_1096',
        answer: 'coin_1097',
      },
      {
        title: 'coin_1098',
        answer: 'coin_1099',
      },
      {
        title: 'coin_1100',
        answer: 'coin_1101',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Volt Inu (VOLT)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_1102',
        text: ['coin_1106'],
      },
      {
        title: 'coin_1103',
        text: ['coin_1107'],
      },
      {
        title: 'coin_1104',
        text: ['coin_1108', 'coin_1109', 'coin_1110', 'coin_1111', 'coin_1112'],
      },
      {
        title: 'coin_1105',
        text: ['coin_1113', 'coin_1114', 'coin_1115', 'coin_1116', 'coin_1117'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-volt-inu-v2-and-how-to-use-it-to-gain-profit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/04/VOLT_blog.png',
        imageAlt: 'What is Volt Inu V2 and How To Use It to Gain Profit?',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
